import React from 'react';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ExpandIcon: React.FC<React.PropsWithChildren<unknown>> = () => {
	return <FontAwesomeIcon icon={faExpand} />;
};

export default ExpandIcon;
